var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0024 38.4044V39.0876C31.0024 39.2688 30.9304 39.4426 30.8023 39.5707C30.6742 39.6989 30.5004 39.7708 30.3192 39.7708H18.0211C17.8399 39.7708 17.6661 39.6989 17.5379 39.5707C17.4098 39.4426 17.3378 39.2688 17.3378 39.0876V38.4044L19.3875 37.0379V32.9385H28.9527V37.0379L31.0024 38.4044Z",
    fill: "#A4B0C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5677 30.7042H41.4541V29.8179V13.207C41.4541 12.2018 41.0491 11.2402 40.3323 10.5332C39.6159 9.82659 38.6469 9.43176 37.6389 9.43176H9.81517C8.80722 9.43176 7.83815 9.82659 7.12176 10.5332C6.40496 11.2402 6 12.2018 6 13.207V29.8179V30.7042H6.88635H40.5677Z",
    fill: "#EDF7FF",
    stroke: "#4C5B66",
    strokeWidth: 1.7727
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8236 34.2496V36.9087L30.8179 37.795V38.6814C30.8179 38.9165 30.7478 39.1419 30.6232 39.3081C30.4985 39.4743 30.3294 39.5677 30.1531 39.5677H18.1873C18.011 39.5677 17.842 39.4743 17.7173 39.3081C17.5926 39.1419 17.5226 38.9165 17.5226 38.6814V37.795L19.5169 36.9087V30.7042",
    stroke: "#474C54",
    strokeWidth: 1.7727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9658 20.068C22.1267 20.068 25.4998 16.6949 25.4998 12.534C25.4998 8.37308 22.1267 5 17.9658 5C13.8048 5 10.4318 8.37308 10.4318 12.534C10.4318 16.6949 13.8048 20.068 17.9658 20.068Z",
    fill: "white",
    stroke: "#474C54",
    strokeWidth: 1.7727
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9516 15.3546C11.6394 17.1168 12.9602 18.5587 14.6554 19.3982C16.3505 20.2376 18.298 20.4142 20.1165 19.8932C21.9349 19.3722 23.4935 18.1913 24.487 16.5815C25.4805 14.9718 25.8374 13.0492 25.4878 11.1902C25.1382 9.33112 24.1074 7.66948 22.597 6.53057C21.0867 5.39166 19.2056 4.85749 17.3221 5.03264C15.4386 5.20778 13.6883 6.07963 12.4138 7.4775C11.1394 8.87537 10.4326 10.6986 10.4318 12.5902H24.487",
    stroke: "#474C54",
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0203 20.1771V5C18.0203 5 26.6929 11.5045 18.0203 20.1771Z",
    stroke: "#474C54",
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0204 9.43344C18.0204 9.43344 9.34777 15.9379 18.0204 24.6105",
    stroke: "#474C54",
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0452 20.068H37.9087",
    stroke: "#474C54",
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0452 18.2953H37.9087",
    stroke: "#474C54",
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0452 21.8407H37.9087",
    stroke: "#474C54",
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93181 29.3747H41.4541V31.5906C41.4541 32.0607 41.1293 32.5116 40.5511 32.8441C39.9729 33.1765 39.1888 33.3633 38.3711 33.3633H9.08296C8.26531 33.3633 7.48115 33.1765 6.90298 32.8441C6.32481 32.5116 6 32.0607 6 31.5906V28.9315",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93181 29.3747H41.4541V31.5906C41.4541 32.0607 41.1293 32.5116 40.5511 32.8441C39.9729 33.1765 39.1888 33.3633 38.3711 33.3633H9.08296C8.26531 33.3633 7.48115 33.1765 6.90298 32.8441C6.32481 32.5116 6 32.0607 6 31.5906V28.9315",
    stroke: "#474C54",
    strokeWidth: 1.7727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88636 12.0908V28.0452H40.5677L6.88636 12.0908Z",
    fill: "#CCE1F1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9658 20.068C22.1267 20.068 25.4998 16.6949 25.4998 12.534C25.4998 8.37308 22.1267 5 17.9658 5C13.8048 5 10.4318 8.37308 10.4318 12.534C10.4318 16.6949 13.8048 20.068 17.9658 20.068Z",
    fill: "white",
    stroke: "#474C54",
    strokeWidth: 1.7727
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9516 15.3546C11.6394 17.1168 12.9602 18.5587 14.6554 19.3982C16.3505 20.2376 18.298 20.4142 20.1165 19.8932C21.9349 19.3722 23.4935 18.1913 24.487 16.5815C25.4805 14.9718 25.8374 13.0492 25.4878 11.1902C25.1382 9.33112 24.1074 7.66948 22.597 6.53057C21.0867 5.39166 19.2056 4.85749 17.3221 5.03264C15.4386 5.20778 13.6883 6.07963 12.4138 7.4775C11.1394 8.87537 10.4326 10.6986 10.4318 12.5902H24.487",
    stroke: "#474C54",
    strokeOpacity: 0.4,
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0203 20.1788V5.00168C18.0203 5.00168 26.6929 11.5061 18.0203 20.1788Z",
    stroke: "#474C54",
    strokeOpacity: 0.4,
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0204 5.00168C18.0204 5.00168 9.34777 11.5061 18.0204 20.1788",
    stroke: "#474C54",
    strokeOpacity: 0.4,
    strokeWidth: 0.886352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9315 24.4997H31.298",
    stroke: "#474C54",
    strokeWidth: 1.7727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4318 24.4997H11.7982",
    stroke: "#474C54",
    strokeWidth: 1.7727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7271 24.7708H37.2687",
    stroke: "#474C54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLink);
export default __webpack_public_path__ + "static/media/add_link.6c1ec3fdc46aa8c984527fe098e31671.svg";
export { ForwardRef as ReactComponent };